/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type MoveItemsSubscription_change$ref: FragmentReference;
declare export opaque type MoveItemsSubscription_change$fragmentType: MoveItemsSubscription_change$ref;
export type MoveItemsSubscription_change = {|
  +roleHasBeenRemoved?: boolean,
  +policiesToMoveUp?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +policiesToMoveDown?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +rolesToMoveUp?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +rolesToMoveDown?: $ReadOnlyArray<{|
    +databaseId: string
  |}>,
  +$refType: MoveItemsSubscription_change$ref,
|};
export type MoveItemsSubscription_change$data = MoveItemsSubscription_change;
export type MoveItemsSubscription_change$key = {
  +$data?: MoveItemsSubscription_change$data,
  +$fragmentRefs: MoveItemsSubscription_change$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "databaseId",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MoveItemsSubscription_change",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roleHasBeenRemoved",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "policiesToMoveUp",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "policiesToMoveDown",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "rolesToMoveUp",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "rolesToMoveDown",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "type": "MoveItemsChange",
      "abstractKey": null
    }
  ],
  "type": "DescribeChangeable",
  "abstractKey": "__isDescribeChangeable"
};
})();
// prettier-ignore
(node/*: any*/).hash = '4f5c95a42361567bcaa9d348097db8c2';

module.exports = node;
